var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52536 4.0625C6.06059 4.0625 4.0625 6.06059 4.0625 8.52536V21.5996C4.0625 24.0644 6.06059 26.0625 8.52536 26.0625H21.5996C24.0644 26.0625 26.0625 24.0644 26.0625 21.5996V8.52536C26.0625 6.06059 24.0644 4.0625 21.5996 4.0625H8.52536ZM12.2339 15.0625C12.2339 14.5418 11.8118 14.1196 11.2911 14.1196C10.7703 14.1196 10.3482 14.5418 10.3482 15.0625L10.3482 21.3482C10.3482 21.8689 10.7703 22.2911 11.2911 22.2911C11.8118 22.2911 12.2339 21.8689 12.2339 21.3482V15.0625ZM15.0625 16.6339C15.5832 16.6339 16.0054 17.0561 16.0054 17.5768V21.3482C16.0054 21.8689 15.5832 22.2911 15.0625 22.2911C14.5418 22.2911 14.1196 21.8689 14.1196 21.3482V17.5768C14.1196 17.0561 14.5418 16.6339 15.0625 16.6339ZM19.7768 12.5482C19.7768 12.0275 19.3547 11.6054 18.8339 11.6054C18.3132 11.6054 17.8911 12.0275 17.8911 12.5482V21.3482C17.8911 21.8689 18.3132 22.2911 18.8339 22.2911C19.3547 22.2911 19.7768 21.8689 19.7768 21.3482V12.5482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.298a1f32ed4381d26e8bae2a8ca69b35.svg";
export { ForwardRef as ReactComponent };